import type { DocMigration } from "../docMigration";

export function getDatumId(handle): string | undefined {
  switch (handle?.type) {
    case "LEVEL":
      return handle.levelId;
    case "ROOM":
      return handle.roomId;
    case "LEVEL_DATUM":
      return handle.datumId;
    case "STAIR_BLOCK":
      return handle.stairBlockId;
    default:
      return undefined;
  }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_230: DocMigration = {
  maxSchemaVersion: "0.0.230",
  description: "Convert handles to IDs for datum references",
  apply(json: any) {
    for (const blockId in json.stairBlocks) {
      const block = json.stairBlocks[blockId];
      if (block.datumVerticalLower && block.datumVerticalLower["type"]) {
        block.datumVerticalLower = getDatumId(block.datumVerticalLower);
      }
      if (block.datumVerticalUpper && block.datumVerticalUpper["type"]) {
        block.datumVerticalUpper = getDatumId(block.datumVerticalUpper);
      }
      if (block.datumVertical && block.datumVertical["type"]) {
        block.datumVertical = getDatumId(block.datumVertical);
      }
    }

    return json;
  },
};

export default migration_0_0_230;
